<template>
    <div class="all-products-detail">
        <div class="products-detail-header">
            <div class="products-detail-header01">
                <span>{{ detailsObj.fundname }}</span>
                <span>{{ detailsObj.fundcode }}</span>
            </div>
            <div class="products-detail-header02">
                <ul>
                    <!-- <li>
                        <span class="li-01">{{ perfBenchmark || "--" }}</span>
                        <span class="li-02">收益基准</span>
                    </li> -->
                    <li>
                        <span class="li-01">{{ investmentterm }}</span>
                        <span class="li-02">投资期限</span>
                    </li>
                    <li>
                        <span class="li-01">
                            {{ fundDetail.managername ? fundDetail.managername : "--" }}
                        </span>
                        <span class="li-02">投资经理</span>
                    </li>
                    <li>
                        <span>
                            <ul class="ul-01">
                                <li
                                    v-for="item in riskLevelList"
                                    :key="item.subitem"
                                    :class="
                                        parseInt(detailsObj.risklevel) === parseInt(item.subitem)
                                            ? 'active'
                                            : ''
                                    "
                                >
                                    {{ "R" + item.subitem }}
                                </li>
                            </ul>
                        </span>
                        <span class="li-02">风险等级</span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="products-detail-table">
            <div class="topNav">
                <ul>
                    <li
                        v-for="(item, index) in topNavLis"
                        :key="index"
                        :class="item.check ? 'active' : ''"
                        v-on:click="setactive(item.title)"
                    >
                        {{ item.title }}
                    </li>
                </ul>
            </div>
            <div class="products-detail-content">
                <!-- 单位净值走势 -->
                <div v-show="active === 0">
                    <div class="dataNav">
                        <ul>
                            <li
                                v-for="(item, index) in dataLis"
                                :key="index"
                                :class="relatetypeActive === item.active ? 'active' : ''"
                                v-on:click="handleChange(index)"
                            >
                                {{ item.title }}
                            </li>
                        </ul>
                    </div>
                    <div v-show="hasNavData" class="data-echart">
                        <div ref="productNavChart" style="height: 300px" />
                    </div>
                    <div v-show="!hasNavData" class="chart-empty">暂无净值数据</div>
                </div>
                <!-- 净值列表 -->
                <div v-show="active === 1" class="products-info">
                    <el-table :data="navList" class="jz-table" style="width: 100%">
                        <el-table-column align="center" label="日期">
                            <template slot-scope="scope">
                                <span>{{ $util.fmtDate(scope.row.navdate, "/") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="单位净值">
                            <template slot-scope="scope">
                                <span>{{ $util.fmtNum(scope.row.nav, scope.row.navsize) }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="跌涨幅">
                            <template slot-scope="scope">
                                <span
                                    :class="
                                        Number(scope.row.dayfloatprofit) > 0
                                            ? 'add'
                                            : Number(scope.row.dayfloatprofit) < 0
                                            ? 'reduce'
                                            : ''
                                    "
                                >
                                    {{ formatterRate(scope.row.dayfloatprofit) }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        layout="prev, pager, next"
                        prev-text="< 上一页"
                        next-text="下一页 >"
                        :total="productsNum2"
                        :current-page.sync="navCurPage"
                        v-on:current-change="currentChange2"
                    />
                </div>
                <!-- 产品公告 -->
                <div v-show="active === 4" class="products-info">
                    <div class="products-info-select">
                        <el-select
                            v-model="relatetypeValue"
                            placeholder="请选择"
                            v-on:change="handleChangerelatetype"
                        >
                            <el-option
                                v-for="item in dataLis2"
                                :key="item.active"
                                :label="item.title"
                                :value="item.active"
                            />
                        </el-select>
                        <el-select v-model="noticeType" v-on:change="handleChgNoType">
                            <el-option
                                v-for="item in typeList"
                                :key="item.subitem"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </div>
                    <template v-if="noticeType !== 'relevance'">
                        <div v-if="productsInfoData.length > 0" class="products-info-list">
                            <div
                                v-for="(item, index) in productsInfoData"
                                :key="index"
                                class="products-info-item"
                                v-on:click="handlerJump(item)"
                            >
                                <span>
                                    {{ item.title || item.originalname || "--" }}
                                </span>
                                <span>{{ fmtTime(item) }}</span>
                            </div>
                        </div>
                        <div v-else class="products-info-list no-data">暂无数据</div>
                        <el-pagination
                            layout="prev, pager, next"
                            prev-text="< 上一页"
                            next-text="下一页 >"
                            :total="productsNum"
                            :current-page.sync="currentpage"
                            v-on:current-change="currentChange"
                        />
                    </template>
                    <template v-else>
                        <div class="relate_title">关联方公示</div>
                        <el-table
                            v-loading="relevanceLoading"
                            :data="tableData"
                            border
                            style="width: 100%"
                            :span-method="objectSpanMethod"
                            :header-row-style="{ fontWeight: 'bold' }"
                        >
                            <el-table-column prop="relatetype" label="类别" width="250" />
                            <el-table-column prop="relatename" label="关联方" />
                        </el-table>
                        <div v-if="tableData.length === 0" class="no-data">数据接入中</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
import * as echarts from "echarts";
import format from "date-fns/format";
export default {
    name: "ProductDetail",
    components: {},
    data() {
        return {
            detailsObj: {},
            topNavLis: [
                { title: "单位净值走势", check: true, active: 0 },
                { title: "净值列表", check: false, active: 1 },
                { title: "产品公告", check: false, active: 4 }
            ],
            dataLis: [
                { title: "近一月", active: 0 },
                { title: "近三月", active: 1 },
                { title: "近六月", active: 2 },
                { title: "近一年", active: 3 },
                { title: "今年以来", active: 4 },
                { title: "成立以来", active: 5 }
            ],
            dataLis2: [
                { title: "全部时间", active: 0 },
                { title: "近一个月", active: 1 },
                { title: "近三个月", active: 2 },
                { title: "近半年", active: 3 },
                { title: "近一年", active: 4 },
                { title: "近三年", active: 5 },
                { title: "今年以来", active: 6 },
                { title: "成立以来", active: 7 }
            ],
            active: 0,
            relatetypeActive: 3, // 默认近一年
            hasNavData: false,
            investmentterm: "",
            // 净值列表
            navList: [],
            navPagecount: 10,
            navPageoffset: 1,
            navCurPage: 1,
            productsNum2: 0,
            // 产品详情（用于投资经理、收益基准等）
            fundDetail: {},
            // 收益基准（从 getFundDetails 返回的 ext 字段解析"业绩比较基准"）
            perfBenchmark: "",
            // 公告
            relatetypeValue: 0,
            productsInfoData: [],
            productsNum: 0,
            relatetypeObj: { beginrelatetype: "", endrelatetype: "" },
            currentpage: 1,
            noticeType: "",
            // 关联方
            relevanceLoading: false,
            needToMergeColumns: ["relatetype"],
            tableData: []
        };
    },
    computed: {
        // 风险等级字典数组，subitem 为 01-05，subitemname 为字典值
        riskLevelList() {
            return this.$cache.getDict("110143") || [];
        },
        // 公告子类型下拉：首项"全部"、末项"关联方公示"，中间从字典 90137 动态获取
        typeList() {
            const dict = this.$cache.getDict("90137") || [];
            return [
                { subitem: "", subitemname: "全部公告" },
                ...dict
                // { subitem: "relevance", subitemname: "关联方公示" }
            ];
        }
    },
    mounted() {
        let cache;
        try {
            cache = JSON.parse(sessionStorage.getItem("privateFundDetail") || "{}");
        } catch (e) {
            cache = {};
        }
        const fundcode = cache && cache.fundcode;
        if (!fundcode) {
            this.$message && this.$message.error && this.$message.error("未获取到产品信息");
            return;
        }
        this.initDetail(fundcode);
    },
    beforeDestroy() {
        if (this.navChartInst) {
            window.removeEventListener("resize", this.resizeNavChart);
            this.navChartInst.dispose();
            this.navChartInst = null;
        }
    },
    methods: {
        // 从 qryPageProductService 查询产品信息，取第一条结果集作为 detailsObj
        async initDetail(fundcode) {
            // 优先使用 sessionStorage 中带入的持仓行数据
            let cache;
            try {
                cache = JSON.parse(sessionStorage.getItem("privateFundDetail") || "{}");
            } catch (e) {
                cache = {};
            }

            // 如果缓存中有完整的基金信息，直接使用
            if (cache && cache.fundcode === fundcode && cache.fundname) {
                this.detailsObj = cache;
            } else {
                // 否则通过接口补全产品信息
                const res = await fundApi.getFundLists({
                    keyword: fundcode,
                    pagesize: 10,
                    pagenum: 1,
                    ignoretradingmethodflag: "1"
                });
                if (res && res.data && res.data.list && res.data.list.length > 0) {
                    // 校验返回的 fundcode 是否与目标一致
                    const matchedFund = res.data.list.find((item) => item.fundcode === fundcode);
                    this.detailsObj = matchedFund || { fundcode: fundcode };
                } else {
                    this.detailsObj = { fundcode: fundcode };
                }
            }
            // 查询投资期限（investmentterm）
            this.getTradeDetail();

            // 先加载净值走势图，完成后再加载净值列表，避免相同接口并发冲突
            this.$nextTick(async () => {
                await this.getNavChart("5");
                // 走势图加载完成后再加载列表
                this.getNavList();
            });

            this.getFundExt();
            this.getNoticeList();
        },
        // 切换 Tab
        setactive(val) {
            this.topNavLis.forEach((item) => {
                item.check = item.title === val;
                if (item.title === val) {
                    this.active = item.active;
                }
            });
        },
        // Tab1 - 区间切换
        handleChange(i) {
            this.relatetypeActive = i;
            // datetype: 3=近一月 6=近3个月 4=近半年 5=近一年 10=今年以来 1=成立以来
            const mapCode = ["3", "6", "4", "5", "10", "1"];
            this.getNavChart(mapCode[i]);
        },
        async getNavChart(datetype) {
            try {
                const res = await fundApi.getNavHistoryList({
                    fundcode: this.detailsObj.fundcode,
                    datetype: datetype,
                    isasc: "1",
                    pagesize: 99999,
                    pagenum: 1
                });
                if (res && res.data && res.data.list && res.data.list.length > 0) {
                    const list = res.data.list;
                    const xData = [];
                    const navArr = [];
                    let minVal = Number(list[0].nav);
                    list.forEach((item) => {
                        xData.push(this.$util.fmtDate(item.navdate));
                        const nv = this.$util.fmtNum(item.nav, 4);
                        navArr.push(nv);
                        if (Number(item.nav) < minVal) {
                            minVal = Number(item.nav);
                        }
                    });
                    this.hasNavData = true;
                    this.$nextTick(() => {
                        this.renderNavChart(xData, navArr, minVal);
                    });
                } else {
                    this.hasNavData = false;
                    if (this.navChartInst) {
                        this.navChartInst.clear();
                    }
                }
            } catch (error) {
                // 接口失败时显示空状态，不影响其他功能
                this.hasNavData = false;
            }
        },
        // 本地绘制净值走势图（不影响其他页面的公共 chart 组件）
        renderNavChart(xData, navArr, minVal) {
            const dom = this.$refs.productNavChart;
            if (!dom) return;
            if (!this.navChartInst) {
                this.navChartInst = echarts.init(dom);
                window.addEventListener("resize", this.resizeNavChart);
            }
            const option = {
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "line",
                        lineStyle: { type: "dashed", color: "#999" },
                        label: { backgroundColor: "#6a7985" }
                    }
                },
                color: ["#e51c23"],
                grid: { left: "2%", right: "4%", bottom: "3%", top: "20px", containLabel: true },
                xAxis: [{ type: "category", boundaryGap: false, data: xData }],
                yAxis: [
                    {
                        type: "value",
                        min: minVal ? Number(0.9 * minVal).toFixed(4) : 0,
                        axisLabel: {
                            formatter: (v) => Number(v).toFixed(4)
                        }
                    }
                ],
                series: [
                    {
                        name: "单位净值",
                        type: "line",
                        smooth: true,
                        showSymbol: false,
                        symbolSize: 6,
                        emphasis: { scale: true, focus: "series" },
                        data: navArr,
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: "#e51c23" },
                                { offset: 1, color: "rgba(255,255,255,0)" }
                            ])
                        }
                    }
                ]
            };
            this.navChartInst.setOption(option, true);
            this.navChartInst.resize();
        },
        resizeNavChart() {
            if (this.navChartInst) this.navChartInst.resize();
        },
        // 查询基金交易详情获取投资期限
        async getTradeDetail() {
            const fundcode = this.detailsObj && this.detailsObj.fundcode;
            if (!fundcode) return;
            const res = await fundApi.qryFundTradeDetail({
                fundcode: fundcode,
                sharetype: this.detailsObj.sharetype || ""
            });
            if (res && res.data) {
                const d = Array.isArray(res.data) ? res.data[0] || {} : res.data;
                this.investmentterm = d.investmentterm
                    ? this.$cache.getDict("150071", d.investmentterm) || d.investmentterm
                    : "--";
            }
        },
        // Tab2 - 净值列表
        async getNavList() {
            try {
                const res = await fundApi.getNavHistoryList({
                    fundcode: this.detailsObj.fundcode,
                    startdate: "",
                    enddate: "",
                    isasc: "0",
                    pagesize: this.navPagecount,
                    pagenum: this.navPageoffset
                });
                if (res && res.data) {
                    this.navList = res.data.list || [];
                    this.productsNum2 = res.data.total ? parseInt(res.data.total) : 0;
                }
            } catch (error) {
                // 接口失败时显示空列表，不影响其他功能
                this.navList = [];
                this.productsNum2 = 0;
            }
        },
        currentChange2(num) {
            this.navPageoffset = num;
            this.getNavList();
        },
        // 查询产品详情（用于投资经理、收益基准等），并解析 ext 中的"业绩比较基准"
        async getFundExt() {
            const res = await fundApi.getFundDetails({ fundcode: this.detailsObj.fundcode });
            if (!res || !res.data || !res.data[0]) {
                return;
            }
            const d = res.data[0];
            this.fundDetail = d;
            // 解析 ext 字段：格式形如 [{"definition":"业绩比较基准","content":"..."}]
            this.perfBenchmark = this.parsePerfBenchmark(d.ext);
        },
        // 从 ext 字段中解析"业绩比较基准"内容
        parsePerfBenchmark(ext) {
            if (this.$util.isEmpty(ext)) return "";
            let list = ext;
            if (typeof ext === "string") {
                try {
                    list = JSON.parse(ext);
                } catch (e) {
                    return "";
                }
            }
            if (!Array.isArray(list)) return "";
            const target = list.find((it) => it && it.definition === "业绩比较基准");
            return target && target.content ? String(target.content) : "";
        },
        // Tab5 - 公告
        async getNoticeList(num) {
            const params = {
                fundcode: this.detailsObj.fundcode,
                pagesize: 10,
                pagenum: num || this.currentpage,
                begintime: this.relatetypeObj.beginrelatetype,
                endtime: this.relatetypeObj.endrelatetype,
                noticeclass: "1",
                type: this.noticeType || ""
            };
            const res = await fundApi.getAnnouncement(params);
            if (res && res.data) {
                // 兼容两种返回结构：数组 或 { list, total }
                if (Array.isArray(res.data)) {
                    this.productsInfoData = res.data;
                    this.productsNum = res.alllength ? parseInt(res.alllength) : res.data.length;
                } else {
                    this.productsInfoData = res.data.list || [];
                    this.productsNum = res.data.total ? parseInt(res.data.total) : 0;
                }
            } else {
                this.productsInfoData = [];
                this.productsNum = 0;
            }
        },
        currentChange(num) {
            this.currentpage = num;
            this.getNoticeList(num);
        },
        handlerJump(item) {
            let targetUrl = "";
            // 优先使用 fileid 通过统一文件下载地址
            if (!this.$util.isEmpty(item.fileid)) {
                targetUrl = this.$util.imgSrc({ fileCode: item.fileid });
            } else if (!this.$util.isEmpty(item.link)) {
                // 校验 link 的协议，只允许 http/https
                const link = item.link;
                if (link.startsWith("http://") || link.startsWith("https://")) {
                    targetUrl = link;
                } else {
                    // 非法协议（javascript:、data: 等），不打开
                    return;
                }
            }

            if (targetUrl) {
                // 使用 noopener,noreferrer 防止反向标签页劫持
                window.open(targetUrl, "_blank", "noopener,noreferrer");
            }
        },
        handleChgNoType() {
            if (this.noticeType === "relevance") {
                this.fetchPrivateRelate();
                return;
            }
            this.currentpage = 1;
            this.getNoticeList(1);
        },
        handleChangerelatetype(num) {
            const now = new Date();
            // 保持 YYYYMMDD 格式用于接口查询和日期计算
            const endrelatetype = format(now, "YYYYMMDD");

            this.relatetypeObj.endrelatetype = endrelatetype;
            switch (num) {
                case 0: // 全部时间
                    this.relatetypeObj.beginrelatetype = "";
                    this.relatetypeObj.endrelatetype = "";
                    break;
                case 1: // 近一个月
                    this.relatetypeObj.beginrelatetype = this.$util.getBeginDate(endrelatetype, 1);
                    break;
                case 2: // 近三个月
                    this.relatetypeObj.beginrelatetype = this.$util.getBeginDate(endrelatetype, 3);
                    break;
                case 3: // 近半年
                    this.relatetypeObj.beginrelatetype = this.$util.getBeginDate(endrelatetype, 6);
                    break;
                case 4: // 近一年
                    this.relatetypeObj.beginrelatetype = this.$util.getBeginDate(endrelatetype, 12);
                    break;
                case 5: // 近三年
                    this.relatetypeObj.beginrelatetype = this.$util.getBeginDate(endrelatetype, 36);
                    break;
                case 6: // 今年以来
                    this.relatetypeObj.beginrelatetype = now.getFullYear() + "0101";
                    break;
                case 7: // 成立以来
                default:
                    this.relatetypeObj.beginrelatetype = "";
                    this.relatetypeObj.endrelatetype = "";
                    break;
            }
            this.currentpage = 1;
            this.getNoticeList(1);
        },
        // 关联方公示 —— 占位实现，后续接入 U8-TIS-21128 替换此方法
        fetchPrivateRelate() {
            this.relevanceLoading = false;
            this.tableData = [];
        },
        // 合并列
        objectSpanMethod({ row, column, rowIndex }) {
            if (this.needToMergeColumns.indexOf(column.property) !== -1) {
                const currentValue = row[column.property];
                const preRow = this.tableData[rowIndex - 1];
                const preValue = preRow ? preRow[column.property] : null;
                if (currentValue === preValue) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.tableData.length; i++) {
                        const nextRow = this.tableData[i];
                        if (nextRow[column.property] === currentValue) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return { rowspan: rowspan, colspan: 1 };
                }
            }
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (rate === "" || rate === null) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate) + "%";
        },
        fmtTime(item) {
            const t = item.publishtime || item.updatetime || item.createtime;
            if (!t) return "--";
            // 后端返回格式如 20260402101842，取前 8 位 YYYYMMDD 转为 YYYY-MM-DD
            return this.$util.fmtDate(String(t).substring(0, 8));
        }
    }
};
</script>

<style lang="scss" scoped>
.all-products-detail {
    padding: 42px 40px 20px 40px;
    background: #fff;
    .relate_title {
        width: 100%;
        text-align: center;
        height: 50px;
        line-height: 50px;
        font-size: 22px;
        font-weight: bold;
    }
    ::v-deep .el-table__body tr:hover > td {
        background-color: transparent !important;
    }
    .products-detail-header {
        .products-detail-header01 {
            & > span:first-child {
                color: #434a54;
                font-size: 18px;
            }
            & > span:nth-child(2) {
                color: #ccc;
                font-size: 18px;
                margin: 0 5px;
            }
        }
        .products-detail-header02 {
            margin: 18px 0;
            ul {
                width: 100%;
                display: flex;
                justify-content: space-around;
                align-items: center;
                li {
                    width: 25%;
                    display: flex;
                    flex-direction: column;
                    & > span:first-child {
                        ul {
                            width: 70%;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            li {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 20px;
                                height: 20px;
                                background-color: #f4f5f7;
                                font-size: 12px;
                                font-weight: normal;
                                color: #999999;
                            }
                            .active {
                                background: #ff9b44;
                                color: #fff;
                            }
                        }
                    }
                    & > span:nth-child(2) {
                        color: #999999;
                        margin: 5px 0;
                    }
                }
                .li-01 {
                    height: 24px;
                    line-height: 24px;
                    font-size: 16px;
                }
                .li-02 {
                    height: 24px;
                    line-height: 24px;
                    font-size: 14px;
                }
            }
        }
    }
    .products-detail-table {
        .topNav {
            height: 42px;
            border-bottom: 1px solid #d8d8d8;
            margin: 37px 0 0 0;
            ul {
                display: flex;
                li {
                    padding: 0 20px;
                    height: 34px;
                    text-align: center;
                    line-height: 34px;
                    font-size: 16px;
                    color: #434a54;
                    cursor: pointer;
                    background-color: #f5f5f5;
                    margin: 0 12px 6px 0;
                }
                .active {
                    color: #e51c23;
                    height: 42px;
                    line-height: 42px;
                    background-color: #fff;
                    border: 1px solid #d8d8d8;
                    border-bottom: none;
                }
            }
        }
        .dataNav {
            margin-top: 37px;
            ul {
                display: flex;
                li {
                    border-radius: 2px;
                    padding: 0 16px;
                    height: 34px;
                    text-align: center;
                    line-height: 34px;
                    font-size: 16px;
                    color: #999999;
                    cursor: pointer;
                    margin-right: 10px;
                }
                .active {
                    background-color: #d0af7a;
                    color: #fff;
                }
            }
        }
        .data-echart {
            margin-top: 20px;
        }
        .chart-empty {
            text-align: center;
            padding: 60px 0;
            color: #999;
        }
        .products-detail-content {
            .shuxingtiao {
                width: 4px;
                height: 15px;
                border-radius: 2px;
                background: #e51c23;
                display: inline-block;
            }
            .div02 {
                margin-top: 27px;
            }
            .text-info {
                margin: 0 10px;
                font-size: 16px;
                color: #333;
            }
            .flex-row {
                display: flex;
                align-items: center;
                padding: 10px 0;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 5px;
                tr {
                    width: 100%;
                    .td01 {
                        width: 20%;
                        text-align: center;
                        background: #f7f7f7;
                        border: 1px solid #fff;
                        padding: 10px;
                    }
                    .td02 {
                        width: 30%;
                        text-align: left;
                        background: #fff;
                        padding: 10px;
                        border: 1px solid #f7f7f7;
                    }
                }
            }
            .jz-table {
                margin-bottom: 10px;
                ::v-deep td {
                    height: 44px;
                    line-height: 44px;
                    padding: 0;
                }
                .add {
                    color: $risk5;
                }
                .reduce {
                    color: $risk1;
                }
            }
            .no-fee-tip {
                padding: 10px 0;
                color: #999;
                font-size: 14px;
            }
        }
    }
    .products-info {
        .products-info-select {
            padding: 10px 0;
            border-bottom: 1px dashed #d8d8d8;
            ::v-deep .el-input__inner {
                border: 0;
                width: 110px;
            }
        }
        .products-info-list {
            .products-info-item {
                padding: 1.5rem 1rem;
                border-bottom: 1px dashed #d8d8d8;
                display: flex;
                justify-content: space-between;
                align-items: center;
                cursor: pointer;
                .info {
                    background: #ff6b6b;
                    color: #fff;
                    padding: 2px;
                    font-size: 12px;
                    margin: 0 4px;
                    border-radius: 6px;
                }
            }
        }
        .no-data {
            text-align: center;
            padding: 1rem 0;
            color: #999;
        }
        ::v-deep .el-pagination {
            padding: 1rem 2px;
            margin-bottom: 0;
            text-align: right;
        }
    }
    ::v-deep .el-table thead th {
        font-weight: bold;
    }
}
</style>
